import React from "react";
import { Link } from "react-router-dom";
import logo from "../logo.png";
import "../App.css";

const Header = () => {
  return (
    <header className="main-header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <img src={logo} alt="Hacky Apps Logo" className="site-logo" />
          <span className="site-title">Hacky Apps</span>
        </Link>
        <nav className="main-nav">
          <Link className="nav-link" to="/about">
            About
          </Link>
          <Link className="nav-link" to="/pricing">
            Pricing
          </Link>
          <Link className="nav-link" to="/contact">
            Contact
          </Link>
        </nav>
        <a href="#contact" className="cta-btn">
          Say Hello
        </a>
      </div>
    </header>
  );
};

export default Header;
